import { render, staticRenderFns } from "./OTPVerifiedModal.vue?vue&type=template&id=457dd8c6&scoped=true&"
import script from "./OTPVerifiedModal.vue?vue&type=script&lang=js&"
export * from "./OTPVerifiedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457dd8c6",
  null
  
)

export default component.exports